import React from 'react';

const SplashScreen = ({ fadeOut }) => {
  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-white transition-opacity duration-1000 ease-in-out ${
        fadeOut ? 'opacity-0' : 'opacity-100'
      }`}
      style={{ pointerEvents: fadeOut ? 'none' : 'auto' }}
    >
      <img
        src="/images/logo/PS52LogoTrans.png"
        alt="P.S. 052 Logo"
        className="h-32 w-auto sm:h-80"
      />
    </div>
  );
};

export default SplashScreen; 